// import Swiper bundle with all modules
import { gsap } from "gsap";
import { Howl } from "howler";

export default class Main {
  constructor() {
    this.sounds = [];
    this.currentSound = 0;
    this.init();
  }

  init() {
    this.setZoom();
    this.setSwitch();
    this.setVoice();
    this.setSecretReveal();
  }

  setZoom() {
    const wrapper = document.querySelector(".character");
    const btn = document.querySelector(".js-zoombtn");
    btn.addEventListener("click", () => {
      if (wrapper.getAttribute("data-zoom") === "1") {
        wrapper.setAttribute("data-zoom", "0");
      } else {
        wrapper.setAttribute("data-zoom", "1");
      }
    });

    const relWrapper = document.querySelector(".relpic ");
    const relbtn = document.querySelector(".js-relzoombtn");
    relbtn.addEventListener("click", () => {
      if (relWrapper.getAttribute("data-relzoom") === "1") {
        relWrapper.setAttribute("data-relzoom", "0");
      } else {
        relWrapper.setAttribute("data-relzoom", "1");
      }
    });
  }

  setSwitch() {
    const wrapper = [...document.querySelectorAll(".js-typewrap")];
    const btns = [...document.querySelectorAll(".js-2d3dswitch")];

    btns.forEach((btn) => {
      btn.addEventListener("click", () => {
        const btnType = btn.getAttribute("data-type");
        wrapper.forEach((item) => item.setAttribute("data-type", btnType));
      });
    });
  }

  setVoice() {
    const voices = [...document.querySelectorAll(".js-voice")];

    const resetState = (activeIndex) => {
      voices.forEach((el, index) => {
        if (index !== activeIndex) {
          el.removeAttribute("data-active");
          this.sounds[index].stop();
        }
      });
    };

    voices.forEach((el, index) => {
      const sound = new Howl({
        src: [el.getAttribute("data-src")],
      });

      sound.on("end", () => {
        el.setAttribute("data-active", "0");
      });

      this.sounds.push(sound);

      el.addEventListener("click", () => {
        if (!el.getAttribute("data-active")) {
          resetState(index);
          el.setAttribute("data-active", "1");

          if (this.currentSound !== index) {
            sound.seek(0);
          }
          sound.play();
          this.currentSound = index;
        } else {
          sound.pause();
          el.removeAttribute("data-active");
        }
      });
    });
  }

  setSecretReveal() {
    const txt = document.querySelector(".js-secrettxt");
    const btn = txt.querySelector("span");
    btn.addEventListener("click", () => {
      txt.removeAttribute("data-secret");
    });
  }
}
